import _ from 'lodash';

const DEPRECATED_EMAIL_DOMAIN = 'wayin.info';

/**
 * Filters out the list of available email domains in the account to get rid of deprecated one
 */
const filterNonDeprecatedDomains = _.memoize(
  (domainOptions) => domainOptions.filter((domain) => domain.value !== DEPRECATED_EMAIL_DOMAIN),
  (domainOptions) => `cache-${JSON.stringify(domainOptions)}`
);

/**
 * Parses the email domains from the account settings (can be something like: '[wayin.info mydomain.com]').
 * Also removes wayin.info from the list, if there are some user custom domains available.
 */
const getFilteredDomains = _.memoize(
  (accountEmailDomains) => {
    let domainOptions = accountEmailDomains.map((domain) => ({ text: '@' + domain, value: domain }));

    // In scope of getting rid of the wayin.info domain, check if there are another domains assigned to the account
    // and remove wayin.info, if it's not the only one
    if (domainOptions.length > 1) {
      domainOptions = filterNonDeprecatedDomains(domainOptions);
    }

    return domainOptions;
  },
  (accountEmailDomains) => `cache-${JSON.stringify(accountEmailDomains)}`
);

/**
 * Looks for a selected domain name in the list of available email domains in the account.
 * If it does not exist - retuns null, so the validation will make the user to select an existent one.
 */
const getAvailableSelectedDomain = _.memoize(
  (domainOptions, domainName) => (_.some(domainOptions, { value: domainName }) ? domainName : null),
  (domainOptions, domainName) => `cache-${JSON.stringify(domainOptions)}-${domainName}`
);

export default {
  getFilteredDomains,
  getAvailableSelectedDomain,
  filterNonDeprecatedDomains,
  DEPRECATED_EMAIL_DOMAIN,
};
